import { MsClose as T } from "@sunrise/icons";
import { screenSizeDetection as N, pageUtils as y } from "@sunrise/shared";
import { trackWithBaseTracking as D } from "@sunrise/tracking";
import { defineComponent as G, ref as _, computed as f, watch as h, nextTick as O, toRef as U } from "vue";
import B from "./index139.js";
import W from "./index26.js";
import j from "./index44.js";
import { useKeyboardNavigation as q } from "./index524.js";
import { useTouchNavigation as z } from "./index525.js";
import { useMouseNavigation as E } from "./index526.js";
const ee = G({
  name: "CsGallery",
  components: {
    MsClose: T,
    CsSwiper: j,
    CsImageSource: W,
    MsAdPlace: B
  },
  model: {
    prop: "isVisible",
    event: "update:isVisible"
  },
  props: {
    images: {
      type: Array,
      required: !0
    },
    ads: {
      type: Array,
      default: () => []
    },
    startIndex: {
      type: Number,
      default: 0
    },
    isVisible: Boolean,
    trackingParameter: Object
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const { isScreenM: o } = N(), i = _(
      "rtl"
      /* RTL */
    ), a = f(() => F(e.images, e.ads)), n = _(v(e.startIndex, a)), l = f(() => a.value[n.value]), u = f(() => {
      var r;
      return (r = l.value) == null ? void 0 : r.isAd;
    }), c = f(() => {
      var r, s, p;
      return !((r = l.value) != null && r.isAd) && ((p = (s = l.value) == null ? void 0 : s.image) == null ? void 0 : p.author);
    });
    h(
      () => e.startIndex,
      (r) => n.value = v(r, a)
    ), h(
      () => e.isVisible,
      async (r) => {
        if (!r) {
          y.enablePageScroll(), n.value = v(e.startIndex, a);
          return;
        }
        y.disablePageScroll(), g("galerie_open", n.value, u.value, e.trackingParameter), e.ads.length > 0 && (await O(
          /* let ad-slots be rendered */
        ), window.addNewAdUnits(e.ads.map((s) => s.id)));
      }
    );
    function d() {
      i.value = "rtl", n.value = x(n.value + 1, a.value.length), g("galerie_rechts", n.value, u.value, e.trackingParameter);
    }
    function m() {
      i.value = "ltr", n.value = x(n.value - 1, a.value.length), g("galerie_links", n.value, u.value, e.trackingParameter);
    }
    function b() {
      t("update:isVisible", !1);
    }
    function I(r) {
      var s;
      return r.isAd ? "Werbung" : ((s = r.image) == null ? void 0 : s.description) || "";
    }
    const { onTouchEnd: k, onTouchMove: S, onTouchStart: w } = z(d, m), { onMouseDown: M, onMouseMove: C, onMouseUp: V, isGrabbing: P } = E(d, m);
    return q(d, m, b, U(e, "isVisible")), {
      determineDescription: I,
      onTouchEnd: k,
      onTouchMove: S,
      onTouchStart: w,
      isScreenM: o,
      activeIndex: n,
      next: d,
      prev: m,
      direction: i,
      content: a,
      closeGallery: b,
      currentSlide: l,
      showAuthor: c,
      onMouseDown: M,
      onMouseMove: C,
      onMouseUp: V,
      isGrabbing: P
    };
  }
});
function v(e, t) {
  return t.value.findIndex((o) => o.index === e + 1);
}
function A(e, t, o) {
  return o.find((i) => i.position === t + e + 1);
}
function F(e, t) {
  let o = 0;
  const i = e.map((n, l) => {
    const u = A(l, o, t), c = {
      isAd: !1,
      image: n,
      index: l + 1
    };
    return u ? (o++, [
      {
        isAd: !0,
        adContent: u
      },
      c
    ]) : [c];
  }).flat(), a = A(i.length, 0, t);
  return a && i.push({
    isAd: !0,
    adContent: a
  }), i;
}
function x(e, t) {
  return e < 0 ? t - 1 : e % t;
}
function g(e, t, o, i) {
  if (!i)
    return;
  const a = {
    mslayer_element_text: "bilderstrecke",
    mslayer_element_variant: o ? "advertising" : "picture",
    mslayer_element_body_type: "lightbox",
    mslayer_element_position: t + 1,
    mslayer_element_type_text: e,
    ...i
  };
  D(a);
}
export {
  ee as default
};
